/* Proaid Nutrition — product page behavior.
   Variant selection, gallery, multi-buy tiers, purchase options
   (selling plans) and Ajax add-to-cart, matching the React
   products.$slug.tsx interaction spec. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variantJson = root.querySelector('[data-variant-json]');
    if (!variantJson) return;
    var variants = JSON.parse(variantJson.textContent);

    var state = {
      variant: null,
      qty: 1,
      tierSave: 0,
      sellingPlanId: null,
      subscribeSave: 10
    };

    var variantInput = root.querySelector('[data-variant-id]');
    state.variant = variants.find(function (v) { return String(v.id) === String(variantInput && variantInput.value); }) || variants[0];

    var qtyInput = root.querySelector('[data-qty-input]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    var form = root.querySelector('.pdp__form');

    function money(cents) { return window.theme.formatMoney(cents); }

    function currentUnitPrice() {
      if (state.sellingPlanId) {
        var allocation = (state.variant.selling_plan_allocations || []).find(function (a) {
          return String(a.selling_plan_id) === String(state.sellingPlanId);
        });
        if (allocation) return allocation.price;
      }
      return state.variant.price;
    }

    /* Estimated line price incl. multi-buy tier saving. The real discount
       is applied at checkout by the store's automatic discount. */
    function estimatedLinePrice() {
      var line = currentUnitPrice() * state.qty;
      if (!state.sellingPlanId && state.tierSave > 0) {
        line = line * (1 - state.tierSave / 100);
      }
      return Math.round(line);
    }

    function render() {
      var priceCurrent = root.querySelector('[data-price-current]');
      var priceCompare = root.querySelector('[data-price-compare]');
      var priceBadge = root.querySelector('[data-price-badge]');
      if (priceCurrent) priceCurrent.textContent = money(state.variant.price);
      var hasCompare = state.variant.compare_at_price > state.variant.price;
      if (priceCompare) {
        priceCompare.hidden = !hasCompare;
        if (hasCompare) priceCompare.textContent = money(state.variant.compare_at_price);
      }
      if (priceBadge) {
        priceBadge.hidden = !hasCompare;
        if (hasCompare) {
          var pct = Math.round(((state.variant.compare_at_price - state.variant.price) / state.variant.compare_at_price) * 100);
          priceBadge.textContent = priceBadge.textContent.replace(/\d+/, pct);
        }
      }

      if (variantInput) variantInput.value = state.variant.id;
      if (qtyInput) qtyInput.value = state.qty;

      if (sellingPlanInput) {
        if (state.sellingPlanId) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = state.sellingPlanId;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }
      }

      var available = state.variant.available;
      var label = available
        ? window.theme.strings.addWithPrice.replace('[price]', money(estimatedLinePrice()))
        : window.theme.strings.soldOut;
      if (addLabel) addLabel.textContent = label;
      if (addButton) addButton.disabled = !available;
      if (stickyAdd) stickyAdd.disabled = !available;
      if (stickyPrice) stickyPrice.textContent = money(estimatedLinePrice());
    }

    /* Variant cards */
    root.querySelectorAll('[data-variant-select]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-variant-select');
        var match = variants.find(function (v) { return String(v.id) === String(id); });
        if (!match) return;
        state.variant = match;
        root.querySelectorAll('[data-variant-select]').forEach(function (b) { b.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        render();
      });
    });

    /* Multi-buy tier cards */
    root.querySelectorAll('[data-tier-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.qty = Number(button.getAttribute('data-tier-qty')) || 1;
        state.tierSave = Number(button.getAttribute('data-tier-save')) || 0;
        root.querySelectorAll('[data-tier-qty]').forEach(function (b) { b.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        render();
      });
    });

    /* Purchase option: one-time vs subscribe */
    var frequencies = root.querySelector('[data-frequencies]');
    root.querySelectorAll('[data-purchase-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        var planId = button.getAttribute('data-purchase-option');
        root.querySelectorAll('[data-purchase-option]').forEach(function (b) { b.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        if (planId) {
          var selected = root.querySelector('[data-selling-plan].is-selected');
          state.sellingPlanId = selected ? selected.getAttribute('data-selling-plan') : planId;
          if (frequencies) frequencies.hidden = false;
        } else {
          state.sellingPlanId = null;
          if (frequencies) frequencies.hidden = true;
        }
        render();
      });
    });

    /* Frequency pills */
    root.querySelectorAll('[data-selling-plan]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.sellingPlanId = button.getAttribute('data-selling-plan');
        root.querySelectorAll('[data-selling-plan]').forEach(function (b) { b.classList.remove('is-selected'); });
        button.classList.add('is-selected');
        render();
      });
    });

    /* Quantity stepper */
    root.querySelectorAll('[data-qty-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var delta = Number(button.getAttribute('data-qty-change'));
        state.qty = Math.max(1, state.qty + delta);
        /* Manual qty change resets the tier selection to the matching tier */
        state.tierSave = state.qty >= 4 ? 15 : state.qty === 3 ? 10 : state.qty === 2 ? 5 : 0;
        syncTierSelection();
        render();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        state.qty = Math.max(1, Number(qtyInput.value) || 1);
        state.tierSave = state.qty >= 4 ? 15 : state.qty === 3 ? 10 : state.qty === 2 ? 5 : 0;
        syncTierSelection();
        render();
      });
    }
    function syncTierSelection() {
      var tierQty = Math.min(4, state.qty);
      root.querySelectorAll('[data-tier-qty]').forEach(function (b) {
        b.classList.toggle('is-selected', Number(b.getAttribute('data-tier-qty')) === tierQty);
      });
    }

    /* Gallery */
    var mainImg = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-gallery-thumb');
        mainImg.removeAttribute('srcset');
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* Ajax add-to-cart (form submit + sticky bar) */
    function addToCart() {
      var item = { id: state.variant.id, quantity: state.qty };
      if (state.sellingPlanId) item.selling_plan = state.sellingPlanId;
      if (addButton) { addButton.setAttribute('aria-busy', 'true'); addButton.disabled = true; }
      window.theme.addToCart(item)
        .catch(function (error) {
          var el = root.querySelector('[data-cart-error]');
          if (el) {
            el.textContent = error.message || window.theme.strings.cartError;
            el.hidden = false;
            window.setTimeout(function () { el.hidden = true; }, 4000);
          }
        })
        .finally(function () {
          if (addButton) { addButton.removeAttribute('aria-busy'); addButton.disabled = !state.variant.available; }
        });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;
        event.preventDefault();
        addToCart();
      });
    }
    if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

    render();
  });
})();
